import React from 'react';
import Video from '../components/Video';

import ContentItemHtml from './ContentItemHtml';

export default (props) => {
  const {
    title,
    content,
    sideBarBoxes
  } = props.page;
  const hasSideBar = sideBarBoxes.length?true:false;

  return (<div>
    {content && 
    content.map(contentItem=>(
      <div>
        {contentItem.type == 'video' &&
          <Video contentItem={contentItem} hasSideBar={hasSideBar}/>
        }

        {contentItem.type == 'image' &&
          <div className="e-img__wrapper">
            <div className="e-img__inner">
              <img src={contentItem.imgUrl} alt={contentItem.imgAlt} />
            </div>
          </div>
        }


        {contentItem.type == 'html' &&
          <ContentItemHtml 
            goToUrl={props.goToUrl}
            content={contentItem.content}
          />
        }
      </div>
    ))}
  </div>)
}